// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"76":"8928f4b9eac5fe7f","832":"f3a17e6737e40147"}[chunkId] + ".js";
};